import {
  SupplementalKnowledgeValue,
  SupplementalKnowledgeValueMessage,
  UpdateSupplementKnowledgeV2Body,
} from 'services/api/supplementKnowledge';

export interface RewriteQuestionDraft {
  rewriteQuestion?: string;
  originQuestions?: SupplementalKnowledgeValueMessage[];
  rewriteQuestionTranslateMap?: Record<string, string>;
}

export const EMPTY_REWRITE_QUESTION_DRAFT: RewriteQuestionDraft = {};

export const hasRewriteQuestionDraft = (draft: RewriteQuestionDraft) => {
  return !!draft.rewriteQuestion || !!draft.originQuestions?.length;
};

export interface EffectiveRewriteQuestionState {
  rewriteQuestion: string;
  originQuestions: SupplementalKnowledgeValueMessage[];
}

export const getEffectiveRewriteQuestionState = (
  supplementalKnowledgeValue: Pick<
    SupplementalKnowledgeValue,
    'rewriteQuestion' | 'originQuestions'
  >,
  draft: RewriteQuestionDraft,
): EffectiveRewriteQuestionState => {
  return {
    rewriteQuestion: draft.rewriteQuestion ?? supplementalKnowledgeValue.rewriteQuestion ?? '',
    originQuestions: draft.originQuestions ?? supplementalKnowledgeValue.originQuestions ?? [],
  };
};

export type RewriteQuestionPayload = Partial<
  Pick<
    NonNullable<UpdateSupplementKnowledgeV2Body['supplementalKnowledgeValue']>,
    'rewriteQuestion' | 'originQuestions'
  >
>;

export const buildRewriteQuestionPayload = (
  supplementalKnowledgeValue: Pick<
    SupplementalKnowledgeValue,
    'rewriteQuestion' | 'originQuestions'
  >,
  draft: RewriteQuestionDraft,
): RewriteQuestionPayload => {
  if (!hasRewriteQuestionDraft(draft)) {
    return {};
  }

  const effective = getEffectiveRewriteQuestionState(supplementalKnowledgeValue, draft);

  return {
    rewriteQuestion: effective.rewriteQuestion,
    originQuestions: effective.originQuestions,
  };
};
